import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { octbApi } from '@/services';
import { useStore } from '@/stores';
import Header from '../Header';
import Sidebar from '../Sidebar';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { product } = useStore();
  useEffect(() => {
    octbApi
      .listProducts()
      .then(res => {
        product.setProducts(res?.products || []);
      })
      .finally(() => {});
  }, [product]);
  return (
    <div className={styles.base}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default BaseLayout;
